import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface SettingsState {
  message_success: any
  address: any
  error: any
}

export const useSettingsStore = defineStore('settings', {
  state: (): SettingsState => ({
    message_success: null,
    address: null,
    error: null,
  }),

  getters: {
    getMessageSentSuccess: (state) => state.message_success,
    getAddress: (state) => state.address,
    getError: (state) => state.error,
  },

  actions: {
    async sendMessage(data: any) {
      try {
        const response = await api().post('configuration/system-messenger/send', data)
        this.message_success = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchAddressByVillageId(villageId: string | number) {
      try {
        const response = await api().get('/configuration/locations/address/' + villageId)
        this.address = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },
  },
})
